module.exports = __webpack_public_path__ + "img/6f4be93.png";